import React, { useEffect, useState } from "react";
import { getVirtualById } from "../../api/app";
import { useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";

const VirtualDetails = () => {
  const { id } = useParams();

  const [virtualDetails, setVirtualDetails] = useState(null);
  const [selectedContent, setSelectedContent] = useState("video");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [decodedInstruction, setDecodedInstruction] = useState("");
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  console.log("virtualDetails", virtualDetails);

  // Function to remove HTML tags from the decoded string
  const removeHtmlTags = (decodedString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(decodedString, "text/html");
    return doc.body.textContent || "";
  };

  const handleVideoEnd = () => {
    if (currentVideoIndex < virtualDetails?.videos?.length - 1) {
      setCurrentVideoIndex((prevIndex) => prevIndex + 1);
    }
  };

  useEffect(() => {
    if (id) {
      getVirtualById(id).then((response) => {
        const decoded = atob(response?.virtual.instruction);
        const cleanedText = removeHtmlTags(decoded);
        setDecodedInstruction(cleanedText);
        setVirtualDetails(response.virtual);
        setLoading(false);
      });
    }
  }, [id]);

  const video = virtualDetails?.cover?.uri;
  const notes = virtualDetails?.description;
  const quiz = virtualDetails?.instruction;
  const project = virtualDetails?.file?.uri;

  console.log("virtualDetails", virtualDetails);
  const handleButtonClick = (contentType) => {
    setSelectedContent(contentType);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="loader">
          <BeatLoader color="#003074" size={20} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="container mx-auto px-4">
        <div className="space-x-2 mb-3">
          <button
            type="button"
            className={`px-4 py-2 rounded ${
              selectedContent === "video"
                ? "bg-blue-500 text-white"
                : "bg-gray-500 text-white"
            }`}
            onClick={() => handleButtonClick("video")}
          >
            Lessons
          </button>
          <button
            type="button"
            className={`px-4 py-2 rounded ${
              selectedContent === "notes"
                ? "bg-blue-500 text-white"
                : "bg-gray-500 text-white"
            }`}
            onClick={() => handleButtonClick("notes")}
          >
            Notes
          </button>
          <button
            type="button"
            className={`px-4 py-2 rounded ${
              selectedContent === "quiz"
                ? "bg-blue-500 text-white"
                : "bg-gray-500 text-white"
            }`}
            onClick={() => handleButtonClick("quiz")}
          >
            Quiz
          </button>
          <button
            type="button"
            className={`px-4 py-2 rounded ${
              selectedContent === "project"
                ? "bg-blue-500 text-white"
                : "bg-gray-500 text-white"
            }`}
            onClick={() => handleButtonClick("project")}
          >
            Project
          </button>
        </div>

        <div className="mt-3">
          {selectedContent === "video" && (
            <>
              {virtualDetails?.videos?.length > 0 ? (
                <div>
                  <div className="mt-2 shadow-md rounded-md p-4 hover:shadow-lg transition">
                    <video
                      key={virtualDetails?.videos[currentVideoIndex]?._id}
                      src={virtualDetails?.videos[currentVideoIndex]?.file?.uri}
                      className="w-full h-32 object-cover rounded"
                      controls
                      autoPlay
                      playsInline
                      onEnded={handleVideoEnd}
                      style={{ height: "330px" }}
                    />
                    <p className="mt-2">Lesson {currentVideoIndex + 1}</p>
                    <p>
                      {virtualDetails?.videos[currentVideoIndex]?.file?.name}
                    </p>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-3 mt-4">
                    {virtualDetails?.videos?.map((virtual, index) => (
                      <div
                        key={virtual._id}
                        className={`bg-white shadow-md rounded-md p-4 hover:shadow-lg transition ${
                          index === currentVideoIndex
                            ? "border-2 border-blue-500"
                            : ""
                        }`}
                        onClick={() => setCurrentVideoIndex(index)}
                      >
                        <video
                          src={virtual?.file?.uri}
                          className="w-full h-30 object-cover rounded"
                          muted
                          playsInline
                          style={{ pointerEvents: "none" }}
                        />
                        <p>Lesson {index + 1}</p>
                        <p className="text-sm text-black-500">
                          {virtual?.file?.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="mt-2 shadow-md rounded-md p-4 hover:shadow-lg transition">
                  <div className="text-center text-gray-500 text-lg font-medium py-10">
                    No lessons available for this content.
                  </div>
                </div>
              )}
            </>
          )}

          {selectedContent === "notes" && notes && (
            <div className="bg-white shadow-md rounded-md p-4 hover:shadow-lg transition">
              <p>{notes}</p>
            </div>
          )}

          {selectedContent === "quiz" && quiz && (
            <div className="bg-white shadow-md rounded-md p-4 hover:shadow-lg transition">
              <p>{decodedInstruction}</p>
            </div>
          )}

          {selectedContent === "project" && project && (
            <div className="bg-white shadow-md rounded-md p-4 hover:shadow-lg transition">
              <div className="flex justify-end">
                <button
                  type="button"
                  className="px-4 py-2 bg-blue-500 text-white rounded"
                  onClick={openModal}
                >
                  View Instruction
                </button>
              </div>
              {project.includes("http") && (
                <div className="mt-2">
                  <iframe
                    src={project}
                    title="Project"
                    className="w-full object-cover"
                    style={{ height: "450px" }}
                  ></iframe>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50"
          onClick={closeModal}
        >
          <div
            className="bg-white w-11/12 sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3 max-w-3xl rounded-lg shadow-lg p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center">
              <h5 className="text-xl font-semibold">
                {virtualDetails?.name} instructions
              </h5>
              <button
                type="button"
                className="text-xl font-bold"
                onClick={closeModal}
              >
                &times;
              </button>
            </div>
            <div className="mt-4">
              <p>{decodedInstruction}</p>
            </div>
            <div className="mt-4 flex justify-end">
              <button
                type="button"
                className="px-4 py-2 bg-gray-300 rounded"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VirtualDetails;
